const counties = [
  'Camden County', 'Burlington County', 'Gloucester County', 'Salem County',
  'Cumberland County', 'Atlantic County', 'Cape May County', 'Ocean County',
  'Monmouth County', 'Mercer County', 'Middlesex County', 'Somerset County',
  'Union County', 'Essex County', 'Hudson County', 'Bergen County',
  'Passaic County', 'Morris County', 'Sussex County', 'Warren County',
  'Hunterdon County',
];

export default function NJInfoSection() {
  return (
    <section className="py-16 md:py-20 bg-gray-900 text-white" id="areas">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2
            className="text-3xl md:text-5xl font-extrabold uppercase text-yellow-400"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            New Jersey
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row-reverse items-start gap-12">
          {/* Left (visually right): images */}
          <div className="w-full lg:w-5/12 flex flex-col gap-6">
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/fae4215ff7d1189025d1768d74f5d23c.jpg"
                alt="New Jersey city streets commercial asphalt paving"
                className="w-full h-[500px] object-cover object-top rounded-lg"
              />
            </div>
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=two%20construction%20workers%20in%20high%20visibility%20vests%20and%20hard%20hats%20operating%20an%20asphalt%20paver%20machine%20on%20a%20commercial%20road%20fresh%20hot%20mix%20asphalt%20being%20laid%20down%20sunny%20day%20professional%20paving%20crew%20at%20work%20close%20up%20realistic%20photo&width=800&height=560&seq=nj-workers-paver-asphalt-01&orientation=landscape"
                alt="Asphalt paving crew workers operating paver machine"
                className="w-full h-[320px] object-cover object-center rounded-lg"
              />
            </div>
          </div>

          {/* Right (visually left): text */}
          <div className="w-full lg:w-7/12 text-gray-300 leading-relaxed space-y-5">
            <p>
              <strong className="text-white">
                <a
                  href="https://www.state.nj.us/"
                  rel="nofollow"
                  target="_blank"
                  className="text-yellow-400 hover:underline"
                >
                  New Jersey
                </a>{' '}
                is one of the most densely populated and commercially active states in the nation.
              </strong>
            </p>
            <p>
              With a thriving economy spanning logistics, retail, healthcare, and manufacturing, the demand for quality commercial asphalt paving has never been higher. From the busy commercial corridors of South Jersey to the industrial parks and shopping centers of Central and North Jersey, properly maintained pavement is essential for businesses and municipalities alike.
            </p>
            <p>
              New Jersey&apos;s climate — with harsh winters, freeze-thaw cycles, and heavy rain — puts enormous stress on asphalt surfaces. That&apos;s why you need a commercial asphalt paving contractor who understands the local conditions and delivers pavement that lasts.
            </p>

            <h4
              className="text-xl font-bold text-white uppercase mt-4"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              Serving the Entire State of New Jersey
            </h4>
            <p>
              As New Jersey&apos;s go-to commercial paving partner, <strong className="text-white">NJ Commercial Asphalt Paving</strong> supports businesses and properties with a wide range of asphalt and concrete services. Whether we&apos;re working with small business owners, property managers, school districts, or public agencies, we bring unmatched professionalism and attention to detail.
            </p>
            <p>
              <strong className="text-white">Counties and areas we serve across New Jersey include:</strong>
            </p>

            <ul className="grid grid-cols-2 gap-2">
              {counties.map((c) => (
                <li key={c} className="flex items-center gap-2 text-sm">
                  <span className="w-2 h-2 bg-yellow-400 rounded-full flex-shrink-0"></span>
                  {c}
                </li>
              ))}
            </ul>

            <p className="mt-4">
              No matter where you are in New Jersey, our team is ready to come to you with immediate availability, professional equipment, and a crew that is fast, clean, and courteous from start to finish.
            </p>
            <p>
              Ready to start your next commercial asphalt paving project?{' '}
              <a href="#contact" className="text-yellow-400 hover:underline font-semibold">
                Contact NJ Commercial Asphalt Paving
              </a>{' '}
              today for a quote or consultation.
            </p>
            <p>
              <strong>
                <em>
                  &quot;From South Jersey to North Jersey, we know asphalt — and we pave it right the first time.&quot;
                </em>
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
